// @flow
import BalanceWidget from './BalanceWidgetContainer'
export default BalanceWidget
